<template>
  <div ref="charts" style="width: 100%; height: 500px"></div>
</template>

<script>
import echarts from "echarts";
import { onMounted, reactive, ref } from "vue";
export default {
  props: {
    echartsData: {
      type: Object,
      default:()=>{}
    },
  },
  setup(props) {
    const charts = ref(null);
     let chart;
     let myChart;
    onMounted(() => {
        chart = charts.value;
        myChart = echarts.init(chart);
        // renderEcharts();
    });

    const renderEcharts = function (echartsData) {
     let option = {
        tooltip: { trigger: "axis" },
        legend: {
          // data:[echartsData.dataName]
          show:false
        },
        xAxis: {
          type: "category",
          data: echartsData.data_time,
          boundaryGap: false, //坐标轴两边不留白
        },
        yAxis: {
          type: "value",
          show:true,
          nameTextStyle:{
              color:'#000',
              fontWeight:800,
              fontSize:14
          }
        },
        grid: {
          y: 80,
          x: 60,
        },
        series: [
          {
            data: echartsData.total,
            type: "line",
            symbolSize: 6,
            smooth: true,
          },

        ],
      }
      console.log(option)
      myChart.setOption(option);
      window.addEventListener("resize", function () {
        myChart.resize();
      });

      window.removeEventListener("resize", function () {
        myChart.resize();
      });
    };
    return {
      charts,
      renderEcharts,
    };
  },
};
</script>